export default __webpack_public_path__ + "static/media/hang.786cd8c4.svg";